import React from 'react';

interface StatusBadgeProps {
  status: string;
  dot?: boolean;
  pulse?: boolean;
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status, dot = true, pulse = false }) => {
  let badgeClass = 'badge-neutral';
  let label = status;

  switch (status.toLowerCase()) {
    case 'online':
    case 'resolved':
    case 'healthy':
    case 'active':
    case 'succeeded':
    case 'sent':
      badgeClass = 'badge-success';
      break;
    case 'degraded':
    case 'warning':
    case 'about_to_lapse':
    case 'past_due':
    case 'pending':
    case 'lagging':
    case 'waiting_customer':
    case 'in_progress':
      badgeClass = 'badge-warning';
      break;
    case 'offline':
    case 'lapsed':
    case 'inactivated':
    case 'critical':
    case 'failed':
    case 'stopped':
    case 'blocked':
    case 'urgent':
      badgeClass = 'badge-danger';
      break;
    case 'info':
    case 'comped':
    case 'trial':
    case 'dispatched':
      badgeClass = 'badge-info';
      break;
    default:
      badgeClass = 'badge-neutral';
  }

  return (
    <span className={`badge ${badgeClass}`}>
      {dot && <span className={`badge-dot ${pulse ? 'pulse' : ''}`} />}
      <span style={{ textTransform: 'capitalize' }}>{label.replace(/_/g, ' ')}</span>
    </span>
  );
};
